import React from 'react';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '../../Icons/Ellipsis';
import { IconSize } from '../../Icons/IconWrap';
import { VisuallyHidden } from '../../a11y';
import { BiEventType } from '../../biLogger';
import IconButtonWithContextMenu from '../../Dropdown2/Preset/IconButtonWithContextMenu';
export var ChatActionsIconWithDropdown = function (_a) {
    var chatroom = _a.chatroom, currentUser = _a.currentUser, onAddToWatch = _a.onAddToWatch, onBlockUser = _a.onBlockUser, onReportUser = _a.onReportUser, onRemove = _a.onRemove, onLeave = _a.onLeave, onCreateGroupChat = _a.onCreateGroupChat, onManage = _a.onManage, onRename = _a.onRename, className = _a.className, _b = _a.size, size = _b === void 0 ? IconSize.SMALL : _b, children = _a.children;
    var t = useTranslation().t;
    if (!chatroom) {
        return null;
    }
    var chatId = chatroom.id, isPrivate = chatroom.isPrivate, createdBy = chatroom.createdBy;
    var isCurrentUserChatCreator = currentUser.useridUuid === createdBy;
    var privateChatSettingsItems = [
        {
            items: [
                // TODOLATER: Hiding for now since the future of this is unclear
                false && {
                    label: t('chat.window.settings.addToWatch'),
                    onClick: onAddToWatch,
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'add to watch',
                    },
                },
                {
                    label: t('chat.window.settings.blockUser'),
                    onClick: function () { return onBlockUser(chatId); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'block user',
                    },
                },
                // TODOLATER: Can't do this right now. Hide it until we can
                false && {
                    label: t('chat.window.settings.reportUser'),
                    onClick: onReportUser,
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'report user',
                    },
                },
                {
                    label: t('chat.window.settings.createGroupChat'),
                    onClick: function () { return onCreateGroupChat(chatId); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'create group chat',
                    },
                },
            ],
        },
        {
            items: [
                {
                    label: t('chat.window.settings.remove'),
                    onClick: function () { return onRemove(chatId); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'remove',
                    },
                },
            ],
        },
    ];
    var groupChatSettingsItems = [
        {
            items: [
                {
                    label: t('chat.window.settings.manage'),
                    onClick: function () { return onManage(chatId); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'manage',
                    },
                },
                isCurrentUserChatCreator && {
                    label: t('chat.window.settings.renameChat'),
                    onClick: function () { return onRename(chatId); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'rename chat',
                    },
                },
            ],
        },
        {
            items: [
                {
                    label: t('chat.window.settings.leave'),
                    onClick: function () { return onLeave(chatroom.id); },
                    biData: {
                        evid: BiEventType.CHAT_DROPDOWN_MENU,
                        menu_item: 'leave',
                    },
                },
            ],
        },
    ];
    var items = (isPrivate
        ? privateChatSettingsItems
        : groupChatSettingsItems).filter(function (item) { return item; });
    return (React.createElement(IconButtonWithContextMenu, { className: className, tooltipText: t('chat.tooltip.settings'), items: items },
        React.createElement(VisuallyHidden, null, t('chat.window.controls.settingsButton')),
        React.createElement(EllipsisIcon, { size: size })));
};
ChatActionsIconWithDropdown.displayName = 'ChatActionsIconWithDropdown';
export default ChatActionsIconWithDropdown;
//# sourceMappingURL=ChatActionsIconWithDropdown.js.map